module.exports = __webpack_public_path__ + "media/images/mv_img_pc-6ca8a03136b6b43e8c30d6d54612d2ed.png";